<template>
  <div class="pg">
    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <template v-else>
      <div class="gov">
        <div class="card"><b>{{ counts.semanal_realizadas }}<span>/52</span></b><small>{{ $t('ARC_PANEL.GOV.WEEKLY') }}</small></div>
        <div class="card"><b>{{ counts.mensais_realizadas }}<span>/12</span></b><small>{{ $t('ARC_PANEL.GOV.MONTHLY') }}</small></div>
        <div class="card"><b>{{ counts.trimestrais_realizadas }}<span>/4</span></b><small>{{ $t('ARC_PANEL.GOV.CLEVEL') }}</small><em v-if="counts.proximo_clevel">{{ $t('ARC_PANEL.GOV.NEXT') }}: {{ fmtDate(counts.proximo_clevel) }}</em></div>
        <div class="card"><b>{{ presenca }}<span>%</span></b><small>{{ $t('ARC_PANEL.GOV.PRESENCE') }}</small></div>
      </div>

      <div class="sec">{{ $t('ARC_PANEL.GOV.DECISIONS') }}</div>
      <div class="card">
        <ul class="log">
          <li v-for="d in decisions" :key="d.id"><span class="date">{{ d.data }}</span><div class="body">{{ d.texto }}<span v-if="d.pilar" class="pl" :class="d.pilar">{{ d.pilar }}</span></div></li>
          <li v-if="!decisions.length" class="muted">{{ $t('ARC_MGMT.DECISIONS.EMPTY') }}</li>
        </ul>
      </div>

      <div class="sec">{{ $t('ARC_PANEL.GOV.MEETINGS') }}</div>
      <div class="card">
        <table>
          <tbody>
            <tr v-for="m in meetings" :key="m.id">
              <td class="date">{{ fmtDate(m.inicio_em) }}</td>
              <td>{{ $t('ARC_MGMT.MEETINGS.TYPES.' + m.tipo) }}<div class="muted small">{{ m.pauta }}</div></td>
              <td><span class="pill" :class="m.status">{{ $t('ARC_MGMT.MEETINGS.STATUS.' + m.status) }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>
<script>
import ArcAPI from 'dashboard/api/arc';
export default {
  data() { return { loading: true, meetings: [], decisions: [], counts: {} }; },
  computed: {
    presenca() {
      const done = this.meetings.filter(m => m.status === 'realizada');
      let tot = 0; let pres = 0;
      done.forEach(m => (m.participantes || []).filter(p => p.lado === 'cliente').forEach(p => { tot += 1; if (p.presente) pres += 1; }));
      return tot ? Math.round((100 * pres) / tot) : 0;
    },
  },
  mounted() { this.load(); },
  methods: {
    async load() {
      this.loading = true;
      try {
        const [m, d] = await Promise.all([ArcAPI.panelMeetings(), ArcAPI.panelDecisions()]);
        this.meetings = m.data.payload || []; this.counts = m.data.counts || {}; this.decisions = d.data.payload || [];
      } finally { this.loading = false; }
    },
    fmtDate(iso) { return iso ? new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' }) : ''; },
  },
};
</script>
<style lang="scss" scoped>
.muted { color: var(--s-500); } .muted.small { font-size: var(--font-size-mini); }
.gov { display: grid; grid-template-columns: repeat(4, 1fr); gap: var(--space-small); }
@media (max-width: 900px) { .gov { grid-template-columns: 1fr 1fr; } }
.card { background: var(--white); border: 1px solid var(--s-100); border-radius: 12px; padding: var(--space-normal); }
.gov .card b { font-size: 22px; color: var(--s-900); display: block; span { color: var(--s-400); font-size: 15px; } }
.gov .card small { color: var(--s-500); font-size: var(--font-size-small); } .gov .card em { display: block; color: var(--w-700); font-size: var(--font-size-mini); font-style: normal; margin-top: 4px; }
.sec { font-size: 11px; font-weight: var(--font-weight-bold); letter-spacing: .6px; color: var(--s-400); text-transform: uppercase; margin: var(--space-normal) 0 var(--space-small); }
.log { list-style: none; margin: 0; padding: 0; }
.log li { display: flex; gap: var(--space-normal); padding: 8px 0; border-top: 1px solid var(--s-75); &:first-child { border-top: 0; } }
.date { color: var(--s-400); font-size: var(--font-size-mini); min-width: 5rem; } .body { flex: 1; color: var(--s-900); font-size: var(--font-size-small); }
table { width: 100%; border-collapse: collapse; } td { padding: 10px; border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-900); } tr:last-child td { border-bottom: 0; }
.pl { margin-left: 8px; display: inline-grid; place-items: center; width: 16px; height: 16px; border-radius: 5px; font-weight: 800; font-size: 10px; &.A { background: #E6F1FC; color: #1E88E5; } &.R { background: #E7F6EE; color: #1F9D63; } &.C { background: #EFECFF; color: #7B61FF; } }
.pill { font-size: var(--font-size-mini); padding: 3px 8px; border-radius: 20px; background: var(--s-75); color: var(--s-500); &.realizada { background: var(--g-100); color: var(--g-700); } &.cancelada { background: var(--r-100); color: var(--r-600); } }
</style>
